// src/api/lenderPortal/notifications.js
import { apiGet, apiPost } from "../client.js";

/**
 * Get notification settings
 * POST: /api/method/dynesourcerapi.notifications.get_my_settings
 */
export async function getNotificationSettings() {
  try {
    const res = await apiPost("/api/method/dynesourcerapi.notifications.get_my_settings", {});
    return res?.message || res?.data || res;
  } catch (error) {
    console.error("❌ Get notification settings error:", error);
    throw error;
  }
}

/**
 * Update notification settings
 * POST: /api/method/dynesourcerapi.notifications.update_my_settings
 */
export async function updateNotificationSettings(payload) {
  try {
    console.log("📤 Update notification settings payload:", payload);
    const res = await apiPost("/api/method/dynesourcerapi.notifications.update_my_settings", payload);
    console.log("✅ Update notification settings response:", res);
    return res?.message || res?.data || res;
  } catch (error) {
    console.error("❌ Update notification settings error:", error);
    throw error;
  }
}

/**
 * Get notifications
 * GET: /api/method/dynesourcerapi.notifications.get_my_notifications?limit=20&unread_only=1
 */
export async function getNotifications({ limit = 20, unread_only = 0 } = {}) {
  try {
    const params = {};
    if (limit) params.limit = limit;
    if (unread_only !== undefined) params.unread_only = unread_only;
    
    const res = await apiGet("/api/method/dynesourcerapi.notifications.get_my_notifications", params);
    return res?.message || res?.data || res;
  } catch (error) {
    console.error("❌ Get notifications error:", error);
    throw error;
  }
}

/**
 * Mark a single notification as read
 * POST: /api/method/dynesourcerapi.notifications.mark_notification_read?notification_name=eb2phosb6q
 */
export async function markNotificationRead(notificationName) {
  if (!notificationName) {
    throw new Error("Missing notification_name for markNotificationRead");
  }
  
  try {
    console.log("📤 Mark notification read:", notificationName);
    const res = await apiPost(
      `/api/method/dynesourcerapi.notifications.mark_notification_read?notification_name=${encodeURIComponent(notificationName)}`,
      {}
    );
    console.log("✅ Mark notification read response:", res);
    return res?.message || res?.data || res;
  } catch (error) {
    console.error("❌ Mark notification read error:", error);
    throw error;
  }
}

/**
 * Mark all notifications as read
 * POST: /api/method/dynesourcerapi.notifications.mark_all_notifications_read
 */
export async function markAllNotificationsRead() {
  try {
    console.log("📤 Mark all notifications read");
    const res = await apiPost("/api/method/dynesourcerapi.notifications.mark_all_notifications_read", {});
    console.log("✅ Mark all notifications read response:", res);
    return res?.message || res?.data || res;
  } catch (error) {
    console.error("❌ Mark all notifications read error:", error);
    throw error;
  }
}

